(function () {
  var FORM_SELECTOR = '.cd-home-footer__signup-form, .cd-contact-form__form';
  var STATUS_SELECTOR = '[data-cd-footer-newsletter-message], .cd-home-footer__newsletter-message, [data-cd-cf-status], .cd-contact-form__status';
  var SUBMIT_SELECTOR = 'button[type="submit"], input[type="submit"]';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function getScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || (document.body && document.body.scrollTop) || 0;
  }

  function getFormType(form) {
    var input = form.querySelector('input[name="form_type"]');
    return input && input.value ? input.value : '';
  }

  function getSuccessQuery(form) {
    var type = getFormType(form);

    if (type === 'contact') return 'contact_posted=true';
    if (type === 'customer') return 'customer_posted=true';

    return '';
  }

  function getReturnTargetId(form) {
    if (form.id) return form.id;

    var section = form.closest('[id]');
    return section && section.id ? section.id : '';
  }

  function getSamePageReturnTo(form) {
    var successQuery = getSuccessQuery(form);
    var targetId = getReturnTargetId(form);
    var path = window.location.pathname || '/';
    var returnTo = path;

    if (successQuery) returnTo += '?' + successQuery;
    if (targetId) returnTo += '#' + targetId;

    return returnTo;
  }

  function ensureSamePageReturnTo(form) {
    var type = getFormType(form);

    if (type !== 'contact' && type !== 'customer') return;

    var input = form.querySelector('input[name="return_to"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'return_to';
      form.insertBefore(input, form.firstChild);
    }

    input.value = getSamePageReturnTo(form);
  }

  function setSubmitting(form, isSubmitting) {
    form.classList.toggle('is-submitting', isSubmitting);
    form.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');

    toArray(form.querySelectorAll(SUBMIT_SELECTOR)).forEach(function (button) {
      button.disabled = isSubmitting;
    });
  }

  function updateContactFullName(form) {
    var fullName = form.querySelector('[data-cd-cf-full-name]');
    if (!fullName) return;

    var firstName = form.querySelector('[data-cd-cf-first-name]');
    var lastName = form.querySelector('[data-cd-cf-last-name]');
    fullName.value = [firstName && firstName.value, lastName && lastName.value]
      .filter(Boolean)
      .join(' ')
      .trim();
  }

  function findReplacementForm(form, doc) {
    if (form.id) {
      var byId = doc.getElementById(form.id);
      if (byId && byId.matches && byId.matches('form')) return byId;
    }

    if (form.classList.contains('cd-home-footer__signup-form')) {
      return doc.querySelector('.cd-home-footer__signup-form');
    }

    if (form.classList.contains('cd-contact-form__form')) {
      return doc.querySelector('.cd-contact-form__form');
    }

    return doc.querySelector(FORM_SELECTOR);
  }

  function focusStatusWithoutMoving(form) {
    var status = form.querySelector(STATUS_SELECTOR);
    if (!status || typeof status.focus !== 'function') return;

    try {
      status.focus({ preventScroll: true });
    } catch (error) {
      // Old browsers can throw on the object argument. Do not call focus() again,
      // because that can trigger the exact scroll jump this file prevents.
    }
  }

  function replaceFormContents(form, replacement) {
    var scrollY = getScrollY();
    var activeElement = document.activeElement;

    form.innerHTML = replacement.innerHTML;
    ensureSamePageReturnTo(form);
    window.scrollTo(0, scrollY);
    focusStatusWithoutMoving(form);

    if (activeElement && activeElement !== document.body && document.contains(activeElement)) {
      try {
        activeElement.blur();
      } catch (error) {}
    }

    document.dispatchEvent(new CustomEvent('cleerdent:ajax-form:updated', {
      detail: {
        form: form
      }
    }));
  }

  function nativeSubmit(form) {
    ensureSamePageReturnTo(form);
    form.dataset.cdAjaxFallback = 'true';
    if (form.submit) {
      form.submit();
      return;
    }
    HTMLFormElement.prototype.submit.call(form);
  }

  function submitForm(event) {
    var form = event.currentTarget;

    if (form.dataset.cdAjaxFallback === 'true') return;
    if (!window.fetch || !window.FormData || !window.DOMParser) return;

    if (form.checkValidity && !form.checkValidity()) {
      return;
    }

    event.preventDefault();
    updateContactFullName(form);
    ensureSamePageReturnTo(form);
    setSubmitting(form, true);

    var scrollY = getScrollY();
    var formData = new FormData(form);
    var method = (form.getAttribute('method') || 'post').toUpperCase();
    var action = form.getAttribute('action') || window.location.href;

    fetch(action, {
      method: method,
      body: formData,
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html'
      }
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var replacement = findReplacementForm(form, doc);

        if (!replacement) {
          throw new Error('No matching Cleerdent form found in Shopify response.');
        }

        replaceFormContents(form, replacement);
        window.scrollTo(0, scrollY);
        setSubmitting(form, false);
      })
      .catch(function () {
        setSubmitting(form, false);
        nativeSubmit(form);
      });
  }

  function bindForms(context) {
    toArray((context || document).querySelectorAll(FORM_SELECTOR)).forEach(function (form) {
      ensureSamePageReturnTo(form);

      if (form.dataset.cdAjaxBound === 'true') return;
      form.dataset.cdAjaxBound = 'true';
      form.addEventListener('submit', submitForm);
    });
  }

  function boot() {
    bindForms(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindForms(event.target);
  });
})();
